import React from 'react';
import { Money } from 'shared/types/product/Money';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import useLocale from 'helpers/hooks/useLocale';
import Typography from '../../../atoms/typography';

interface Props {
  discountedPrice?: Money;
  price?: Money;
}

const Prices: React.FC<Props> = ({ price, discountedPrice }) => {
  const { ctLocale: locale } = useLocale();
  if (price === undefined) return;
  return (
    <>
      {discountedPrice ? (
        <div className="flex gap-x-2 sm:flex-col sm:gap-y-2">
          <p className="font-body text-14 font-normal leading-[14px] text-[#4B4B4B] line-through">
            RRP {CurrencyHelpers.formatForCurrency(price ?? '', locale)}
          </p>
          <p className="font-body text-16 font-bold leading-4 text-[#E30616]">
            Now{CurrencyHelpers.formatForCurrency(discountedPrice, locale)}
          </p>
        </div>
      ) : (
        <Typography className="font-body text-16 font-bold leading-[16.8px] text-primary-black">
          {CurrencyHelpers.formatForCurrency(price ?? '', locale)}
        </Typography>
      )}
    </>
  );
};

export default Prices;
